import React from 'react';
import {
  Backdrop,
  Drawer,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {
  BubbleChart,
  // PeopleAlt,
  // RecentActors,
  // WbSunny,
  FindInPage,
  PaymentSharp,
  MonetizationOn,
} from '@material-ui/icons';
import clsx from 'clsx';
import { useHistory } from 'react-router';
// import { resetJoblist } from "controllers/job";

const useStyles = makeStyles({
  drawerContainer: {
    width: 250,
    zIndex: 1001,
    marginTop: 54,
    paddingTop: 11,
  },
  backdrop: {
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
  },
  menuItem: {
    borderLeft: '2px solid #fff',
    paddingLeft: 22,
    margin: '21px 0',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.21px',
    color: '#49515a',

    '& svg': {
      marginRight: 8,
    },
    '&:hover': {
      color: '#4b8c6f',
    },
  },
  menuItemSelected: {
    color: '#4b8c6f',
    borderLeft: '2px solid #4b8c6f',

    '&:hover': {
      cursor: 'default',
    },
  },
});

export const Menu = ({ isOpen = true, toggleView }) => {
  const classes = useStyles();
  const history = useHistory();
  const selectedPath = history.location.pathname;

  const MENU_MAP = [
    {
      Icon: FindInPage,
      title: 'Resume Parser',
      link: '/resume-parser',
      onRouteChange: () => {},
    },
    {
      Icon: BubbleChart,
      title: 'Semantic Matching',
      link: '/talent-ai-matching',
      onRouteChange: () => {},
    },
    // {
    //   Icon: PeopleAlt,
    //   title: 'Pool Recommendation',
    //   link: '/pool-recommendation',
    //   onRouteChange: resetJoblist,
    // },
    // {
    //   Icon: RecentActors,
    //   title: 'Screened Pipe',
    //   link: '/screened-pipe',
    //   onRouteChange: resetJoblist,
    // },
    {
      title: 'lineBreak',
    },
    {
      Icon: PaymentSharp,
      title: 'Analyse IDs',
      link: '/analyse-ids',
      onRouteChange: () => {},
    },
    {
      Icon: MonetizationOn,
      title: 'Analyse Expense',
      link: '/analyse-expense',
      onRouteChange: () => {},
    },
    // {
    //   Icon: WbSunny,
    //   title: 'Ideal Talent Matching',
    //   link: '/ideal-talent-matching',
    //   onRouteChange: () => {},
    // },

    // {
    //   Icon: PeopleAlt,
    //   title: 'Skills Recommendation',
    //   link: '/skills-recommendation',
    // },
  ];

  const navigateTo = (link, onRouteChange) => () => {
    if (link === selectedPath) {
      return false;
    }

    onRouteChange();
    history.push(link);
    toggleView();
  };

  const RenderMenuItem = ({ Icon, title, link, onRouteChange }) => {
    if (title === 'lineBreak') {
      return <hr />;
    }

    const isSelected = selectedPath === link;

    return (
      <Typography
        classes={{
          root: clsx(classes.menuItem, {
            [classes.menuItemSelected]: isSelected,
          }),
        }}
        onClick={navigateTo(link, onRouteChange)}
      >
        <Icon /> {title}
      </Typography>
    );
  };

  return (
    <>
      <Backdrop
        open={isOpen}
        onClick={toggleView}
        classes={{ root: classes.backdrop }}
      />
      <Drawer
        anchor="left"
        open={isOpen}
        onClose={toggleView}
        variant="persistent"
        classes={{ paper: classes.drawerContainer }}
      >
        <Grid container>
          <Grid item xs={12}>
            {MENU_MAP.map((props, i) => (
              <RenderMenuItem key={i} {...props} />
            ))}
          </Grid>
        </Grid>
      </Drawer>
    </>
  );
};
